import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { appendToFormData, urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { CreateBranchPartnerErrorsMapper, CreateBranchPartnerMapper } from '../mappers';
import { CreateBranchPartnerDto } from '../dtos';

export type ICreateBranchPartnerRepoResponse = IRepoResponse<200> | IRepoResponse<422, object> | IRepoResponse<400 | 500, string>;

export type ICreateBranchPartnerRepo = IRepo<[CreateBranchPartnerDto, string | number | undefined], ICreateBranchPartnerRepoResponse>;

export const CreateBranchPartnerRepoType = Symbol.for('CreateBranchPartnerRepo');

@bind(CreateBranchPartnerRepoType)
export class CreateBranchPartnerRepo implements ICreateBranchPartnerRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(dto: CreateBranchPartnerDto, id?: string | number) {
    try {
      const body = new FormData();
      const mappedBody = CreateBranchPartnerMapper.toPersistence(dto);

      appendToFormData(mappedBody, body);

      const url = id ? urlMaker('/api/admin/companies/edit') : urlMaker('/api/admin/companies/create');
      const result = await this.httpClient.post({ url, body });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else if (result.status === 400) {
        const errors = CreateBranchPartnerErrorsMapper.toDomain(result.data.errors);

        return {
          status: 422 as 422,
          response: errors,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      console.error(e);
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
